import moment from 'moment'
import {unitName} from "../../general";

// Mini (thermal) receipt, same as Windows frmReport_ReceiptMini: used instead of the A4 receipt
// and payment slip when System Settings > "Mini Receipt" (customsetting.data.miniReceipt) is on.
// Windows prints it on an 80mm roll (PageWidth 314 = 3.14in), so the page is 80mm wide and as
// long as the content.

const PAGE_WIDTH = 226.77; // 80mm in points

export function isMiniReceipt() {
    try
    {
        let obj = JSON.parse(localStorage.getItem('customsetting'));
        return obj !== null && obj !== undefined && obj.data !== undefined && obj.data !== null && obj.data.miniReceipt === true;
    }
    catch (err)
    {
        return false;
    }
}

function text(v) {
    return v === undefined || v === null ? '' : String(v);
}

function line() {
    return {
        canvas: [{type: 'line', x1: 0, y1: 0, x2: PAGE_WIDTH - 20, y2: 0, lineWidth: 0.5, dash: {length: 2}}],
        margin: [0, 4, 0, 4]
    };
}

function infoRow(label, value) {
    return [
        {text: label, bold: true},
        {text: ':'},
        {text: text(value)}
    ];
}

// r: {title, company, address, tel, partyLabel, name, no, date, method, unitNo, lines: [{desc, amount}],
//     currCode, by, managedBy, footer, wifiLines: [heading, login lines...] or []}
export function miniReceiptDefinition(r) {
    let body = [
        [{text: 'Item(s)', bold: true}, {text: `Amt. (${text(r.currCode)})`, bold: true, alignment: 'right'}]
    ];

    let total = 0;
    for (let l of r.lines || [])
    {
        let amt = parseFloat(l.amount);
        total = total + (isNaN(amt) ? 0 : amt);
        body.push([{text: text(l.desc), font: 'Courier'}, {text: isNaN(amt) ? text(l.amount) : amt.toFixed(2), font: 'Courier', alignment: 'right'}]);
    }

    let content = [
        {text: r.title, fontSize: 12, bold: true, alignment: 'center'},
        {text: text(r.company), fontSize: 10, bold: true, alignment: 'center', margin: [0, 4, 0, 0]},
        {text: text(r.address), alignment: 'center'},
        r.tel ? {text: `Tel: ${r.tel}`, alignment: 'center'} : {text: ''},
        line(),
        {text: text(r.partyLabel), bold: true},
        {text: text(r.name).toUpperCase(), margin: [0, 0, 0, 4]},
        {
            table: {
                widths: [62, 6, '*'],
                body: [
                    infoRow('Receipt No.', r.no),
                    infoRow('Date', r.date),
                    infoRow('Payment Method', r.method),
                    infoRow(`${unitName()} No.`, r.unitNo)
                ]
            },
            layout: 'noBorders'
        },
        line(),
        {
            table: {
                widths: ['*', 60],
                body: body
            },
            layout: 'noBorders'
        }
    ];

    if ((r.lines || []).length > 1)
    {
        content.push({
            table: {
                widths: ['*', 60],
                body: [[{text: 'Total', bold: true}, {text: total.toFixed(2), bold: true, font: 'Courier', alignment: 'right'}]]
            },
            layout: 'noBorders'
        });
    }

    content.push(line());

    if (r.by)
    {
        content.push({text: `${r.byLabel || 'Received By'}: ${r.by}`});
    }

    if (r.managedBy)
    {
        content.push({text: r.managedBy, fontSize: 7, alignment: 'center', margin: [0, 4, 0, 0]});
    }

    if ((r.wifiLines || []).length > 0)
    {
        content.push(line());
        r.wifiLines.forEach((t, idx) => content.push(idx === 0 ? {text: t, bold: true} : {text: t, font: 'Courier'}));
    }

    content.push({text: r.footer ? r.footer : 'Thank you & come again', bold: true, alignment: 'center', margin: [0, 6, 0, 0]});

    return {
        pageSize: {width: PAGE_WIDTH, height: 'auto'},
        pageMargins: [10, 10, 10, 10],
        info: {
            title: `${r.title} - ${text(r.no)}`,
            subject: 'mini receipt',
        },
        content: content,
        defaultStyle: {
            font: 'Helvetica',
            fontSize: 8,
            lineHeight: 1.1
        }
    };
}

export function nowText() {
    return moment().format('DD-MM-YYYY hh:mm:ss A');
}
